"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const data_1 = require("@@/assets/data");
function default_1(lng) {
    switch (lng) {
        case 'ko':
            return data_1.countryKr;
        case 'en':
            return data_1.countryEn;
        case 'ja':
            return data_1.countryJp;
        case 'zh_hans':
            return data_1.countryCn;
        default:
            return data_1.countryKr;
    }
}
exports.default = default_1;
